import React from 'react'
import { Chip } from '@mui/material'
import { Business as BusinessIcon } from '@mui/icons-material'

export const EmployeeTypeChip = ({ type, size = 'small', variant = 'outlined' }) => {
    const config = {
        onroll: { color: 'success', label: 'On Roll', icon: <BusinessIcon fontSize="small" /> },
        outsource: { color: 'info', label: 'Outsource', icon: <BusinessIcon fontSize="small" /> },
    }

    const { color, label, icon } = config[type?.toLowerCase()] || { color: 'default', label: type, icon: null }

    return (
        <Chip
            icon={icon}
            label={label}
            color={color}
            size={size}
            variant={variant}
        />
    )
}
